import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "modules/auth/hooks";
import { useSports } from "modules/sport/hooks";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";

import "./Footer.styles.css";

export const Footer = () => {
  const { user, login, signUp } = useAuth();
  const { sports } = useSports();
  const navigate = useNavigate();
  const location = useLocation();

  const isHome =
    location.pathname === "/" ||
    location.pathname === "/faq" ||
    location.pathname === "/about";

  return (
    <footer
      className="footer-area section-padding-lr"
      style={{ backgroundColor: isHome ? "#000" : "#12222d" }}
    >
      <div className="footer-hm4-ptb">
        <Container fluid style={{ padding: "0 50px" }}>
          <Row>
            <Col lg={3}>
              <div className="footer-widget footer-about">
                <div className="footer-logo">
                  <Link to="#">
                    <Image
                      src="/Staidium_Logo_vertical.svg"
                      width="100"
                      alt=""
                    />
                  </Link>
                </div>
                <p>
                  Connect with Stadium – immerse yourself in the world of
                  amateur sports. Share, network, experience!
                </p>
                <div className="social-style-1">
                  <Link
                    style={{
                      backgroundColor: "#3b5998"
                    }}
                    className="facebook"
                    to={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                    target="_blank"
                  >
                    <FacebookIcon></FacebookIcon>
                  </Link>
                  <Link
                    style={{
                      backgroundColor: "#bd081c"
                    }}
                    className="pinterest"
                    target="_blank"
                    to={`http://pinterest.com/pin/create/button/?url=${window.location.href}`}
                  >
                    <PinterestIcon></PinterestIcon>
                  </Link>
                  <Link
                    style={{
                      backgroundColor: "#0A66C2"
                    }}
                    className="linkedin"
                    target="_blank"
                    to={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`}
                  >
                    <LinkedInIcon></LinkedInIcon>
                  </Link>
                  <Link
                    style={{
                      backgroundColor: "#00B3EC"
                    }}
                    className="instagram"
                    target="_blank"
                    to={`http://twitter.com/share?url=${window.location.href}`}
                  >
                    <TwitterIcon></TwitterIcon>
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="footer-top-right">
                <div className="footer-quicklink">
                  <ul>
                    {sports.map(({ uuid, name }) => (
                      <li>
                        <Link key={uuid} to={`/sport/${name}`}>
                          {name === 'icehockey' ? 'Ice Hockey' : name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="brand-logo-active brand-logo-wrap"
                  style={{ margin: "25px 0" }}
                >
                  <Row
                    className="align-items-center"
                    style={{ justifyContent: "center" }}
                  >
                    <Col lg={2} md={2} xs={4}>
                      <Link to="https://www.telekom.de/start">
                        <Image
                          width={"50%"}
                          height={"40px"}
                          src="/Telekom_Logo.svg"
                        />
                      </Link>
                    </Col>
                    <Col lg={2} md={2} xs={4}>
                      <Link to="https://www.adidas.de/">
                        <Image
                          width={"50%"}
                          height={"40px"}
                          src="/Adidas_Logo.svg"
                        />
                      </Link>
                    </Col>
                    <Col lg={2} md={2} xs={4}>
                      <Link to="https://www.forty10.de/">
                        <Image
                          width={"50%"}
                          height={"40px"}
                          src="/Forty10_Logo.svg"
                        />
                      </Link>
                    </Col>
                  </Row>
                </div>

                <div className="footer-quicklink-2">
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/privacy">Privacy</Link>
                    </li>
                    <li>
                      <Link to="/cookies">Cookie Settings</Link>
                    </li>
                    <li>
                      <Link to="/terms">Terms of Use</Link>
                    </li>
                    <li style={{ display: "none" }}>
                      <Link to="/support">Support</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/pricing">Pricing</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer-bottom footer-bottom-ptb footer-black-hm4">
        <Container
          fluid
          style={{
            backgroundImage: "inherit",
            borderTop: "1px solid #203544",
            padding: "20px 0",
            paddingRight: "50px",
            paddingLeft: "50px"
          }}
        >
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="copyright">
                <p
                  className="copyright-text"
                  style={{
                    margin: "0px"
                  }}
                >
                  Copyright ©2024 All rights reserved | Made by{" "}
                  <Link to="https://sporttotal.com/">SPORTTOTAL</Link>.
                </p>
              </div>
            </Col>
            <Col lg={6} className="d-none d-sm-block d-md-block">
              {!user && (
                <div className="login-alert">
                  <p
                    style={{
                      margin: "0px"
                    }}
                  >
                    <span style={{ marginRight: "5px" }}>
                      Already have an Account?
                    </span>
                    <Link to="#" onClick={login}>
                      LOGIN
                    </Link>
                    <Button
                      style={{
                        marginLeft: "15px",
                        padding: "12px 20px",
                        lineHeight: 1
                      }}
                      className="btn-danger member-btn-style"
                      onClick={signUp}
                    >
                      Become a Member
                    </Button>
                  </p>
                </div>
              )}
            </Col>

            <Col lg={6} className="d-block d-sm-none">
              {!user && (
                <div
                  className="login-alert"
                  style={{
                    display: "inherit"
                  }}
                >
                  <p
                    style={{
                      justifyContent: "center",
                      width: "100%",
                      margin: "0px",
                      marginBottom: "15px"
                    }}
                  >
                    <span style={{ marginRight: "5px" }}>
                      Already have an Account?
                    </span>
                    <Link to="#" onClick={login}>
                      LOGIN
                    </Link>
                  </p>

                  <p
                    style={{
                      justifyContent: "center",
                      width: "100%",
                      margin: "0px",
                      marginBottom: "15px"
                    }}
                  >
                    <Button
                      style={{
                        marginLeft: "15px",
                        padding: "12px 20px",
                        lineHeight: 1
                      }}
                      className="btn-danger member-btn-style"
                      onClick={signUp}
                    >
                      Become a Member
                    </Button>
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};
